// extracted by mini-css-extract-plugin
module.exports = {"root":"ThermostatBarChart_root__3_JFt","loading":"ThermostatBarChart_loading__3-Ziq"};